import { getEnvParam } from "@/env";

export interface PropertyEpc {
    lmk_key: string;
    current_energy_rating: string;
    current_energy_efficiency: number | null;
    potential_energy_rating: string | null;
    potential_energy_efficiency: number | null;
    property_type: string | null;
    built_form: string | null;
    construction_age_band: string | null;
    total_floor_area: number | null;
    co2_emissions_current: number | null;
    main_fuel: string | null;
    tenure: string | null;
    inspection_date: string | null;
    lodgement_date: string | null;
    address1: string | null;
    address2: string | null;
    postcode: string;
    raw: Record<string, unknown> | null;
}

export interface PropertySale {
    uid: string;
    price: number;
    date_of_transfer: string;
    postcode: string | null;
    property_type: string | null;
    age: string | null;
    duration: string | null;
    paon: string | null;
    saon: string | null;
    street: string | null;
}

export interface PropertyUnit {
    uprn: number;
    address: string | null;
    postcode: string | null;
    latest_epc_rating: string | null;
    latest_sale_price: number | null;
    latest_sale_date: string | null;
    epcs: PropertyEpc[];
    sales: PropertySale[];
    attributes: Record<string, number>;
}

export interface PropertyDetails {
    id: number;
    source: string;
    source_id: string;
    units: PropertyUnit[];
}

export async function getPropertyDetails(id: number): Promise<PropertyDetails> {
    const r = await fetch(
        `${process.env.BUN_PUBLIC_TILE_SERVER}/api/properties/${id}/details?${getEnvParam()}`,
        {
            headers: {
                "X-API-KEY": process.env.BUN_PUBLIC_TILE_SERVER_API_KEY,
            },
        },
    );
    if (!r.ok) {
        throw new Error(`Failed to fetch property details: ${r.status}`);
    }
    return r.json();
}
